export const DEBUG_POINT = 'debug-point';
export const LOADER_EMPTY = 'loader-empty';
export const LOADER_FULL = 'loader-full';
export const NIGHT_MASK = 'night-mask';
export const PLANET = 'planet';
export const PLATFORM = 'platform';
export const PLAYER = 'dude';
export const SELECTOR = 'selector';
export const STAR = 'star';
export const TRAP = 'trap';
